export default __webpack_public_path__ + "static/media/kapsurvey-logo.199d7395.svg";